import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Common/Header';
import HomePage from './pages/HomePage';
import Footer from './components/Footer/Footer';
import Error from './pages/Error';
import MultipleProductCards from './components/Common/MultipleProductCards';
import BoloBindassComponent from './components/Common/Bolo-Bindass';
import Abacus from './components/Common/Abacus';
import Coding from './components/Common/Coding';
import VedicMath from './components/Common/VedicMath';
import Class8 from './components/Common/Class-8';
import Class7 from './components/Common/Class-7';
import Class6 from './components/Common/Class-6';
import Class9 from './components/Common/Class-9';
import Class10 from './components/Common/Class-10';
import Class11 from './components/Common/Class-11';
import Class12 from './components/Common/Class-12';
import Contactus from './components/Common/Contactus';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import HowItWorks from './components/Common/HowItWorks';
import AboutUs from './components/Common/Aboutus';
import Careers from './components/Common/Careers';
import './App.css';

function App() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Define paths where Footer should be displayed
  const footerPaths = ["/", "/contact-us", "/privacy-policy", "/terms-of-use", "/howitworks", "/about-us", "/careers"];

  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/batches" element={<MultipleProductCards />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/contact-us" element={<Contactus />} />
        <Route path="/bolo-bindass" element={<BoloBindassComponent />} />
        <Route path="/brain-o-meter" element={<Abacus />} />
        <Route path="/tech-gurukul" element={<Coding />} />
        <Route path="/gurukul-ganit" element={<VedicMath />} />
        <Route path="/Pratham-Prayas" element={<Class6 />} />
        <Route path="/Chhattrapati" element={<Class7 />} />
        <Route path="/Ashtveer" element={<Class8 />} />
        <Route path="/Nauvi-ke-Sikandar" element={<Class9 />} />
        <Route path="/Dasvi-ke-Dangal" element={<Class10 />} />
        <Route path="/Vigyaan-ki-Udaan" element={<Class11 />} />
        <Route path="/Final-Orbit" element={<Class12 />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-of-use" element={<Terms />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        {/* 404 Page */}
        <Route path="*" element={<Error />} />
      </Routes>

      {/* Conditionally render Footer only on specified paths */}
      {footerPaths.includes(location.pathname) && <Footer />}
    </div>
  );
}

export default App;
